import React from "react";
import { useNavigate } from "react-router-dom";
import { createRoomFacilityType } from "adminApi/RoomFacilitesApi/RoomFacilites";
import { RoomFacilityTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import AddRoomFacilityTypeForm from "./Componates/AddRoomFacilityTypeForm";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/RoomFacilityTypeFields.json";

const AddRoomFacilityType = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, RoomFacilityTypeRules);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send plain JSON — no file uploads in this form
    async (formValues) => await createRoomFacilityType({ data: formValues }),
    (vals) => {
      const err = validateForm(vals, RoomFacilityTypeRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Room Facility Type Created Successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddRoomFacilityTypeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default AddRoomFacilityType;
